import { ParsedUrlQuery } from 'querystring'
import { createFilterOptions } from '@mui/material/useAutocomplete'
import { Filter, onChangeFunc } from 'components/core/search-filter/filter'
import { getFilterKeyToLabelMap } from 'components/core/task/ContextualTaskSearchFilter'
import { taskStateToIntl, taskStateToString } from 'components/pages/task/state'
import { TaskState } from 'pbts/c1/api/task/v1/task'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

// TODO(morgabra) centralize these so they don't conflict
export const taskStateQueryParam = 'state'

type taskStateFilterProps = {
    selected: TaskState[] | undefined
    onChange: onChangeFunc<TaskState>
}

const getOptionSelected = (option1: TaskState, option2: TaskState): boolean => {
    return option1 === option2
}

const taskStates = (): TaskState[] => {
    const tt: TaskState[] = []
    for (const ts in TaskState) {
        if ((TaskState[ts] as unknown as number) > 0) {
            tt.push(TaskState[ts] as unknown as TaskState)
        }
    }
    return tt
}

export const TaskStateFilter = ({ selected, onChange }: taskStateFilterProps): React.ReactElement => {
    const intl = useIntl()
    const filterOptions = createFilterOptions<TaskState>({})
    const filterKeyToLabel = getFilterKeyToLabelMap(intl)

    const renderLabel = useCallback(
        (option: TaskState): string => {
            return taskStateToIntl(option, intl)
        },
        [intl],
    )

    // Load initial state from query.
    const fromQuery = useCallback((query: ParsedUrlQuery): TaskState[] => {
        let states = query[taskStateQueryParam]
        if (!states) {
            return []
        }

        if (!Array.isArray(states)) {
            states = [states]
        }

        const parsedStates: TaskState[] = []
        states.forEach((stateStr) => {
            const state = TaskState[stateStr]
            if (!state) {
                return
            }
            parsedStates.push(state)
        })

        return parsedStates
    }, [])

    // Serialize selections to query.
    const toQuery = useCallback((query: ParsedUrlQuery, states: TaskState[]): void => {
        const stateStrs: string[] = []
        states.forEach((state) => {
            const stateStr = taskStateToString(state)
            if (!stateStr) {
                return
            }
            stateStrs.push(stateStr)
        })

        if (stateStrs.length !== 0) {
            query[taskStateQueryParam] = stateStrs
        } else {
            delete query[taskStateQueryParam]
        }
    }, [])

    return (
        <Filter<TaskState>
            label={filterKeyToLabel.status || ''}
            options={taskStates()}
            selected={selected}
            fromQuery={fromQuery}
            toQuery={toQuery}
            onChange={onChange}
            filterOptions={filterOptions}
            getOptionSelected={getOptionSelected}
            renderLabel={renderLabel}
        />
    )
}
